import type { InjectionKey } from 'vue'

export const InjectionI18nTitle: InjectionKey<(...args: any[]) => any> = Symbol('i18nTitle')
